import { render, staticRenderFns } from "./yqg-header.vue?vue&type=template&id=a0f771ba&scoped=true&"
import script from "./yqg-header.js?vue&type=script&lang=js&"
export * from "./yqg-header.js?vue&type=script&lang=js&"
import style0 from "./yqg-header.scss?vue&type=style&index=0&id=a0f771ba&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f771ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f771ba')) {
      api.createRecord('a0f771ba', component.options)
    } else {
      api.reload('a0f771ba', component.options)
    }
    module.hot.accept("./yqg-header.vue?vue&type=template&id=a0f771ba&scoped=true&", function () {
      api.rerender('a0f771ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/snxguarantee/index/component/yqg-header/yqg-header.vue"
export default component.exports